module.exports = __webpack_public_path__ + "static/media/soft.90593448.jpeg";